// extracted by mini-css-extract-plugin
export default {"cls1":"gcbnmpMKPIvCnu5cDQqy","cls2":"YYmPbfyLpAzWUw4nFwQk gcbnmpMKPIvCnu5cDQqy"};